import { Extension } from "@tiptap/core";
import { filterStyle, PRESERVED_STYLE_PROPS } from "./styleProps";

/**
 * Keeps the inline CSS that stored documents carry on their block elements.
 *
 * Tiptap's schema drops any attribute a node does not declare, on save and
 * without a word. For these documents that is not cosmetic: `text-indent`,
 * `page-break-before`, `line-height` and the margins are read back by
 * bac/html_docx.py when it rebuilds the .docx, so losing them changes the
 * printed notice. See styleProps.js.
 *
 * Values are kept verbatim, units included - a `text-indent: 36pt` stays
 * 36pt rather than being normalised to px.
 */
export const PreservedStyles = Extension.create({
  name: "preservedStyles",

  addOptions() {
    return {
      types: ["paragraph", "heading", "listItem"],
      properties: PRESERVED_STYLE_PROPS,
    };
  },

  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          style: {
            default: null,
            parseHTML: (element) =>
              filterStyle(element.getAttribute("style"), this.options.properties) ||
              null,
            // mergeAttributes merges `style` declaration by declaration, so
            // this coexists with TextAlign's text-align rather than replacing
            // it. See getRenderedAttributes in @tiptap/core.
            renderHTML: (attributes) =>
              attributes.style ? { style: attributes.style } : {},
          },
        },
      },
    ];
  },
});

export default PreservedStyles;
